<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="item flight">
    <div class="date">
      <div class="dt">
        {{ utilDateFlightfoxUTC(timeDepart) }}
        <span v-if="utilDateFlightfoxUTC(timeDepart) != utilDateFlightfoxUTC(timeArrive)"> - arrives {{ utilDateFlightfoxUTC(timeArrive) }} </span>
        <span v-if="utilDateFlightfoxUTC(timeDepart) == 'Thu, 18 Sep' && number == 'UA2681'" class="demo">Updated</span>
      </div>
      <div v-if="status" class="status">{{ status }}</div>
      <span v-else-if="tag" class="tags">
        <span class="tag" :class="{ chaperoned: isGroupFlight }">{{ tag }}</span>
      </span>
    </div>
    <div class="provider">
      <div class="col1">
        <div class="icon">&#x2708;</div>
      </div>
      <div class="col2">
        <div class="row">
          <div class="pri">
            {{ airlineTitle }} &middot; {{ number }}
            <span v-if="isCodeshare">(operated by {{ airlineTitleOp }})</span>
          </div>
        </div>
      </div>
    </div>
    <div class="schedule">
      <div class="col1 path">
        <div class="dot top" />
        <div class="line" />
        <div class="dot bot" />
      </div>
      <div class="col2">
        <div class="avatar">
          <img v-if="isCodeshare" :src="airlinesLogo(airlineIataOp)" :alt="airlineIataOp" />
          <img v-else :src="airlinesLogo(airlineIata)" :alt="airlineIata" />
        </div>
        <div class="timing">
          <div class="row">
            <div class="pri">
              <span :class="{ delay: timeDepartOriginal }">{{ utilTime(timeDepart) }}</span>
              <span v-if="timeDepartOriginal" class="original">{{ utilTime(timeDepartOriginal) }}</span>
            </div>
            <div class="sec depart">{{ airportDepartTitle }} ({{ airportDepartIata }})</div>
          </div>
          <div class="row">
            <div class="pri times">
              <span :class="{ delay: timeDepartOriginal }">{{ utilTime(timeArrive) }}</span>
              <span v-if="timeArriveOriginal" class="original">{{ utilTime(timeArriveOriginal) }}</span>
              <span class="days">{{ utilDurationFlightOvernights(timeDepart, timeArrive, true) }}</span>
            </div>
            <div class="sec">{{ airportArriveTitle }} ({{ airportArriveIata }})</div>
          </div>
        </div>
      </div>
      <div class="col3">
        <div class="row">
          {{ cabin }}
        </div>
        <div class="row">
          {{ utilDurationItineraryMinutes(elapsed) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import DateTime from "../../utils/datetime";
import imageUrl from "../../assets/images/WN.png";

const { utilDateFlightfoxUTC, utilTime, utilDurationFlightOvernights, utilDurationItineraryMinutes } = DateTime();

defineProps({
  airlineIata: String,
  airlineIataOp: String,
  airlineTitle: String,
  airlineTitleOp: String,
  airportDepartIata: String,
  airportDepartTitle: String,
  airportArriveIata: String,
  airportArriveTitle: String,
  cabin: String,
  elapsed: Number,
  isCodeshare: Boolean,
  number: String,
  status: String,
  timeDepart: String,
  timeDepartOriginal: String,
  timeArrive: String,
  timeArriveOriginal: String,
  flags: String,
  tag: String,
  isGroupFlight: Boolean,
});

const airlinesLogo = code => {
  if (code === "WN") {
    return imageUrl;
  }
  return `https://www.gstatic.com/flights/airline_logos/70px/${code}.png`;
};
</script>

<style lang="less">
.itinerary {
  .flight {
    @keyframes pulse-red {
      0% {
        background-color: @primary;
      }
      50% {
        background-color: @secondary;
      }
      100% {
        background-color: @primary;
      }
    }

    .demo {
      background: @primary;
      border-radius: 2rem;
      color: @white;
      font-size: 0.625rem;
      font-weight: normal;
      padding: 0.225rem 1rem;
      float: right;
      animation: pulse-red 1s ease-in-out 3;
    }

    .avatar {
      img {
        display: block;
        height: 3rem;
        width: 3rem;
      }
    }

    .status {
      color: @secondary;
      font-weight: normal;
    }

    .delay {
      color: @secondary;
    }

    .original {
      display: none;
      color: @secondary;
      text-decoration: line-through;
    }

    .days {
      font-size: 0.75rem;
      vertical-align: super;
    }

    &:hover {
      .delay {
        display: none;
      }

      .original {
        display: inline-block;
      }
    }
  }
}
</style>
